export default __webpack_public_path__ + "static/media/mywishes-logo-white.0a08d495.png";